import { Map, fromJS } from 'immutable';
import { get } from 'lodash';

import { ACTUALIZE_PACKAGE_SUCCESS } from '../constants/actualization';

const initialState = Map();

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case ACTUALIZE_PACKAGE_SUCCESS: {
      const roomInfo = get(payload, 'data.package.room_info');

      return state.merge(fromJS(roomInfo));
    }

    default:
      return state;
  }
}
